


// function removeEdit(textbody: string): string {

//     const startpattern = '<span class="mw-editsection">'
//     const endpattern = '<span class="mw-editsection-bracket">]</span></span>'
//     const boundaryStrings = new RegExp(`${startpattern}.*${endpattern}`, "g")
//     console.log(textbody)
//     return textbody.replaceAll(boundaryStrings, '')
// }
function formatLinksInString(html: string): string {
    // Create a temporary container to parse the HTML string
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = html;

    // Select all <a> elements inside the container
    const links = tempContainer.querySelectorAll<HTMLAnchorElement>('a');

    links.forEach(link => {
        const href = link.getAttribute('href') || '';

        if (href.startsWith('/wiki')) {
            // Wiki links: highlight in pink (or custom color)
            link.style.color = '#4495cf';
            link.style.textDecoration = 'none';
        } else {
            // Other links: open in a new window
            link.style.color = 'hotpink';
            link.style.textDecoration = 'none';
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer'); // security best practice
        }
    });

    // Return the updated HTML as a string
    return tempContainer.innerHTML;
}

function removeEdit(textbody: string): string {

    // wiki text format changed at some point in 2025. There
    const stringToReplace = '<span>edit</span>'
    return textbody.replaceAll(stringToReplace, '')
}


function removeEmbeddedMapInDistrict(textbody: string): string {
    const startpattern = '<style data-mw-deduplicate="TemplateStyles:r5167221">.mw-parser-output .wv-staticMap'
    const endpattern = '</div></div></div>'
    const boundaryStrings = new RegExp(`${startpattern}.*${endpattern}`, "g")


    return textbody.replaceAll(boundaryStrings, '')
}


function removeEmbeddedMapInSee(textbody: string): string {
    const startpattern = '<link rel="mw-deduplicated-inline-style" href="mw-data:TemplateStyles:r5167221"/>'
    const endpattern = '</div></div></div>'
    const boundaryStrings = new RegExp(`${startpattern}.*${endpattern}`, "g")


    return textbody.replaceAll(boundaryStrings, '')
}


function formatTextbody(textbody: string): string {

    let res = removeEdit(textbody)
    res = removeEmbeddedMapInDistrict(res)
    res = removeEmbeddedMapInSee(res)
    res = formatLinksInString(res)



    return res
}


function removeHeader(textbody: string): string {

    const startpattern = '<h2>'
    const endpattern = '</h2>'
    const boundaryStrings = new RegExp(`${startpattern}.*${endpattern}`, "g")

    return textbody.replaceAll(boundaryStrings, '')
}

export type FormattedWikiSection = {
    sectionName: string
    sectionText: string
}


function formatWikipage(sectionList: string[], wikiPageText: string): FormattedWikiSection[] {

    let payload: FormattedWikiSection[] = []
    // const startpattern = '<h2><span class="mw-headline" id="See">'
    const splitchunk = '<h2'
    const WikiPageSplitted = wikiPageText.split(splitchunk)

    sectionList.forEach((sectionName) => {
        WikiPageSplitted.forEach((WikiPageChunk) => {
            if (WikiPageChunk.includes(` id="${sectionName}">`)) {
                const wikiPageSectionText = WikiPageChunk.split("</h2>")

                payload.push({
                    sectionName: sectionName,
                    sectionText: formatTextbody(wikiPageSectionText[1])
                })
            }
        })

    })

    return payload

}

function handleUmlauts(text: string) {
    return decodeURIComponent(text)
}


export { removeEdit, removeHeader, formatWikipage, handleUmlauts }